import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtualItinerarioEmbarque from '../../actions/itinerario/determinarPaginaAtualItinerarioEmbarque'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoItinerarioEmbarque extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtualItinerarioEmbarque}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualItinerarioEmbarque,
    total: state.itinerarios.total,
    registrosPorPagina: state.registrosPorPaginaAtualItinerarioEmbarque
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtualItinerarioEmbarque }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoItinerarioEmbarque)
